export const ApiNotifications = {
    get: (start = 0, limit = 3) => ({
        url: `/getAdminNotifications?&_sort=id:DESC&_start=${start}&_limit=${limit}`,
        method: 'GET'
    }),
    countUnreadNotifications: () => ({
        url: '/countUnreadNotifications',
        method: 'GET'
    }),
    readNotification: id => ({
        url: 'readNotification',
        method: 'POST',
        data: {
            notification_id: id
        }
    }),
    readAllNotifications: () => ({
        url: 'readAllNotifications',
        method: 'PUT'
    })
};